export class ReservationMonthCapacity {
    public categoryId: number;
    public date: Date;
    public capacity: number[];
}